import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateBankMutationVariables = Types.Exact<{
  bank_id: Types.Scalars["Int"];
  modification?: Types.Maybe<Types.Banks_Set_Input>;
}>;

export type UpdateBankMutation = { __typename?: "mutation_root" } & {
  update_banks?: Types.Maybe<
    { __typename?: "banks_mutation_response" } & {
      returning: Array<
        { __typename?: "banks" } & Pick<Types.Banks, "id" | "name">
      >;
    }
  >;
};

export const UpdateBankDocument = gql`
  mutation UpdateBank($bank_id: Int!, $modification: banks_set_input) {
    update_banks(where: { id: { _eq: $bank_id } }, _set: $modification) {
      returning {
        id
        name
      }
    }
  }
`;

export function useUpdateBankMutation() {
  return Urql.useMutation<UpdateBankMutation, UpdateBankMutationVariables>(
    UpdateBankDocument
  );
}
